import { Badge, Heading } from '@apollo/orbit';
import React from 'react';

import { format } from 'src/lib/format';

import { ColorSwatch } from './ColorSwatch';

export function ErrorGroupName({
  icon,
  rightIcon,
  className,
  children,
}: {
  icon?: React.ReactElement;
  rightIcon?: React.ReactElement;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Heading as="h3" variant="title" className={className}>
      <div className="flex min-w-0 items-center">
        {icon && (
          <span className="mr-1 flex min-w-[24px] shrink-0 items-center justify-center">
            {icon}
          </span>
        )}
        <span className="min-w-0 truncate">{children}</span>
        {rightIcon && (
          <span className="ml-2 flex min-w-[24px] shrink-0 items-center justify-center">
            {rightIcon}
          </span>
        )}
      </div>
    </Heading>
  );
}

export function ErrorGroupTitle({
  title,
  groupColor,
  errorCount,
  icon,
  rightIcon,
}: {
  title: string;
  errorCount: number;
  groupColor: string;
  icon?: React.ReactElement;
  rightIcon?: React.ReactElement;
}) {
  return (
    <div className="flex min-w-0 items-center gap-1">
      <ColorSwatch className="shrink-0" color={groupColor} />
      <ErrorGroupName
        className="flex min-w-0"
        icon={icon}
        rightIcon={rightIcon}
      >
        {title}
      </ErrorGroupName>
      <Badge className="ml-1 flex shrink-0 items-center">
        {format.number(errorCount, '0[.]0a')}
      </Badge>
    </div>
  );
}
